<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M18 23.06a1 1 0 10-1-1.73 1 1 0 101 1.73z"/><path d="M25.84 4.39a2 2 0 00-1.33-.75l-4.71-.59a1 1 0 00-.67.16 1.78 1.78 0 00-.61 0 .4.4 0 00-.15 0L12.7 5.05a1 1 0 00-.51.39 2 2 0 00-1.35.23l-4.33 2.5a2 2 0 00-.73 2.73l9.64 16.7a2 2 0 002.74.73l4.33-2.5a2.07 2.07 0 00.46-.38 1 1 0 00.95-.87l2.35-18.71a2 2 0 00-.41-1.48zm-7 .8l2 13.73-7-12.13zM17.16 26.6L7.51 9.9l4.33-2.5 9.65 16.7zm5.54-8.53L20.85 5.19l3.41.43z"/></svg>